import React, { useEffect, useState } from "react";
import "./PreviousFollowUpPrint.scss";
import moment from "moment";
import SurveyComponent from "pages/RMO/components/cancerTemplate/Template";
import defaultSurveyConfig from "pages/RMO/components/cancerTemplateForm/template";
import PatientDetailsPrintHeader from "components/CommonPrintComponent/PatientDetailsPrintHeader";

export default function PreviousFollowUpPrint({
  followUpData,
  servicesRendered,
  patientDetail,
  componentRef,
  templateJSON,
  appointmentType,
  smartSummaryData,
  vital,
  testLabels,
  appointmentDate
}: any) {

  const [signatureData, setSignatureData] = useState<any>(followUpData?.signatureDetails?.signature ? { "staffSignature": followUpData?.signatureDetails?.signature } : {})

  useEffect(() => {
    if (followUpData?.signatureDetails?.signature) {
      const temp: any = { ...signatureData }
      temp["staffSignature"] = followUpData?.signatureDetails?.signature
      setSignatureData(temp)
    }
  }, [followUpData])


  function camelCase(input: string): string {
    return input
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  return (
    <div
      className="prescriptions-print-wrapper-prev"
      ref={componentRef}
    >
      {/* Patient Details */}
      <PatientDetailsPrintHeader
        patientData={{ patientInfo: patientDetail, vitalsData: null }}
        smartSummaryData={smartSummaryData}
        appointmentDate={appointmentDate}
      />

      {/* Vitals Details */}
      {
        vital && (
          <div className="mb-3">
            <div className={`${testLabels?.some((eachKey: any) => vital[`${eachKey?.field}`]) ? "heading-primary" : "print-hidden-co heading-primary"}`}>Vitals</div>
            <ul className="prev-cn-vital">
              {
                testLabels?.map((item: any, viIndex: any) => {
                  const value = vital?.[item?.field];
                  return value ? (
                    <li className="prev-cn-vital-item" key={viIndex}>
                      <span className="prev-cn-label">{item?.label}:</span>&nbsp;
                      <span>{value}</span>&nbsp;
                      <span>{item?.units}</span>&nbsp;
                    </li>
                  ) : null;
                })
              }
            </ul>

          </div>
        )
      }

      {/* Brief History */}
      {
        followUpData?.briefHistory && (
          <div className="mb-3">
            <div className="heading-primary">Brief History</div>
            <div className="textarea-content">{followUpData?.briefHistory}</div>
          </div>
        )
      }

      {/* Complaints */}
      {
        followUpData?.complaints && (
          <div className="mb-3">
            <div className="heading-primary">Complaints</div>
            <div className="textarea-content">{followUpData?.complaints}</div>
          </div>
        )
      }
      {/* Examination */}
      {
        followUpData?.examination && (
          <div className="mb-3">
            <div className="heading-primary">Examination</div>
            <div className="textarea-content">{followUpData?.examination}</div>
          </div>
        )
      }
      {/* Clinical Impressions */}
      {
        followUpData?.clinicalImpressions && (
          <div className="mb-3">
            <div className="heading-primary">Clinical Impressions</div>
            <div className="textarea-content">{followUpData?.clinicalImpressions}</div>
          </div>
        )
      }
      {/* Notes */}
      {
        followUpData?.notes && (
          <div className="mb-3">
            <div className="heading-primary">Notes</div>
            <div className="textarea-content">{followUpData?.notes}</div>
          </div>
        )
      }
      {/* Prescription Pad */}
      {
        followUpData?.prescriptionPad && followUpData?.prescriptionPad?.filter((e: any) => !e?.isCancelled)?.length > 0 && (
          <section className="chemo-order mb-3">
            <div className="chemo-order-details">
              <div className="pre-medication-container">
                <div className="prescriptions-primary-heading">
                  Prescription Pad
                </div>
                {followUpData?.prescriptionPad?.filter((e: any) => (!e?.isCancelled))?.map((each: any) => {
                  return (
                    <>
                      <div className="prescriptions-secondary-heading">
                        Prescription ID: {each?.prescriptionId}
                      </div>
                      <table className="pre-medication-table-container">
                        <thead>
                          <th>Type</th>
                          <th>Medicine</th>
                          <th>Dose</th>
                          <th>When</th>
                          <th>Frequency</th>
                          <th>Duration</th>
                          <th>Notes/Instructions</th>
                          <th>Side Effects</th>
                        </thead>
                        <tbody>
                          {
                            each?.medicines?.length > 0 ? (
                              each?.medicines?.map((e: any, index: any) => (
                                <tr className="procedure-data">
                                  <td className={e?.type ? "type-pcn" : ''}>{camelCase(e?.type)}</td>
                                  <td className="med-name-pcn">{e?.medicineName}</td>
                                  <td className="dose-pcn">{e?.dose}</td>
                                  <td className={e?.when ? "when-pcn" : ''}>{e?.when}</td>
                                  <td>{e?.frequency}</td>
                                  <td>{e?.duration}</td>
                                  <td>{e?.instructions}</td>
                                  <td className={e?.selectedSideEffects?.length > 0 ? "side-effects-pcn" : ""}>
                                    <ul>
                                      {e?.selectedSideEffects?.map(
                                        (sideEffect: any) => {
                                          return <li>{camelCase(sideEffect)}</li>
                                        }
                                      )}
                                    </ul>
                                  </td>
                                </tr>
                              ))
                            ) : <p>NA</p>
                          }
                        </tbody>
                      </table>
                    </>
                  )
                })
                }
              </div>
            </div>
          </section>
        )
      }
      {/* Services Rendered */}
      {
        appointmentType === "HC" && servicesRendered && servicesRendered?.length > 0 && (
          <section className="chemo-order mb-3">
            <div className="chemo-order-details">
              <div className="pre-medication-container">
                <div className="prescriptions-primary-heading">
                  Services Rendered
                </div>
                <table className="pre-medication-table-container">
                  <thead>
                    <th>#</th>
                    <th>Type</th>
                    <th>Completed By</th>
                  </thead>
                  <tbody>
                    {
                      servicesRendered?.length > 0 ? (
                        servicesRendered?.map((e: any, i: any) => (
                          <tr className="procedure-data">
                            <td>{i + 1}</td>
                            <td>{e?.serviceTemplateName}</td>
                            <td>{e?.completedBy}</td>
                          </tr>
                        ))
                      ) : null
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        )
      }
      {/* Tests Required */}
      {
        followUpData?.testsRequired && followUpData?.testsRequired?.filter((e: any) => !e?.isCancelled)?.length > 0 && (followUpData?.testsRequired?.some((outer: any) => {
          return outer?.tests?.some((inner: any) => inner?.testName);
        })) && (
          <section className="chemo-order mb-3">
            <div className="chemo-order-details">
              <div className="pre-medication-container">
                <div className="prescriptions-primary-heading">Tests Required</div>
                {followUpData?.testsRequired?.filter((e: any) => (!e?.isCancelled))?.map((eachTest: any, outerIndex: any) => {
                  return (
                    <table className="pre-medication-table-container">
                      <thead>
                        <th>Sr.No</th>
                        <th>Test</th>
                        <th>Instructions</th>
                        <th>When</th>
                      </thead>
                      <tbody>
                        {
                          eachTest?.tests?.length > 0 ? (
                            eachTest?.tests?.map((e: any, index: any) => (
                              <tr className="procedure-data">
                                {/* {JSON.stringify(values)} */}
                                <td>{index + 1}</td>
                                <td>
                                  {e?.testName ? e?.testName :
                                    e?.serviceId?.label
                                      ? e?.serviceId?.label
                                      : e?.serviceId
                                        ? e?.serviceId
                                        : ""}
                                </td>
                                <td>{e?.instructions}</td>
                                <td>{e?.when && moment(e?.when).format(
                                  "DD-MM-YYYY")}</td>
                              </tr>
                            ))
                          ) : <p>NA</p>
                        }
                      </tbody>
                    </table>

                  )
                })
                }
              </div>
            </div >
          </section >

        )
      }

      {/* Advice */}
      {
        followUpData?.advice && (
          <div className="mb-3">
            <div className="heading-primary">Advice</div>
            <div className="textarea-content">{followUpData?.advice}</div>
          </div>
        )
      }
      {/* Next Visit */}
      {
        followUpData?.nextVisit && (
          <div className="mb-3">
            <div className="heading-primary">Next Visit</div>
            <div className="textarea-content">{followUpData?.nextVisit?.split('$')?.length > 1 ? followUpData?.nextVisit?.replace(/\$/g, ' ') : moment(followUpData?.nextVisit).format("DD-MM-YYYY")}</div>
          </div>
        )
      }
      {/* Referred To */}
      {
        followUpData?.referredTo?.some((r: any) => (r?.doctorName && r?.doctorName !== "Others") || (r?.doctorName === "Others" && r?.doctorNameOthers)) && (
          <div className="mb-3">
            <div className="heading-primary">Referred To</div>
            <div>
              {
                followUpData?.referredTo?.every((r: any) => !r?.doctorName && !r?.doctorNameOthers && !r?.speciality && !r?.phoneNo && !r?.emailId) ?
                  <p>NA</p>
                  :
                  followUpData?.referredTo?.map((referedTo: any, index: any) => (
                    <table className="refered-to-table-container">
                      <tbody>
                        <tr>
                          <th>Consultant Name : </th>
                          <td>
                            {
                              referedTo?.doctorName === "Others" ?
                                referedTo?.doctorNameOthers ? referedTo?.doctorNameOthers : ""
                                :
                                referedTo?.doctorName
                            }
                          </td>
                          {
                            referedTo?.speciality && (
                              <>
                                <th>Speciality : </th>
                                <td>{referedTo?.speciality}</td>
                              </>
                            )
                          }
                        </tr>
                        <tr>
                          {
                            referedTo?.phoneNo && (
                              <>
                                <th>Phone No : </th>
                                <td>{referedTo?.phoneNo}</td>
                              </>
                            )
                          }
                          {
                            referedTo?.emailId && (
                              <>
                                <th>Email ID : </th>
                                <td>{referedTo?.emailId}</td>
                              </>
                            )
                          }
                        </tr>
                      </tbody>
                    </table>
                  ))
              }
            </div>
          </div>
        )
      }
      {/* Signature Details */}
      {
        followUpData?.signatureDetails && (
          <>
            <div className="heading-primary row">Signature Details</div>
            <div className='col-md-6 d-flex'>
              <div className="heading-primary-text">Name : </div>
              <div className="primary-content">
                {followUpData?.signatureDetails?.name}
              </div>
            </div>
            <div className='col-md-6 d-flex'>
              <div className="heading-primary-text">Date/Time : </div>
              <div className="primary-content">
                {followUpData?.signatureDetails?.dateTime
                  ? moment(followUpData?.signatureDetails?.dateTime).format(
                    "DD-MM-YYYY / HH:mm a"
                  )
                  : ""}
              </div>
            </div>
            <SurveyComponent
              css={defaultSurveyConfig.defaultSurveyCSS}
              data={signatureData}
              json={templateJSON}
              onComplete={(survey: any) => { }}
              hideDot={true}
            />
          </>
        )
      }
    </div >
  )
}
